export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./betconstruct.vue?vue&type=template&id=325cf6f7"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/betconstruct.vue?vue&type=template&id=325cf6f7
// module id = yN2B
// module chunks = 0